import { Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UploadMasterComponent } from './upload-master/upload-master.component';
import { ViewMasterComponent } from './view-master/view-master.component';
import { NotificationComponent } from './notification/notification.component';
import { UserPositionComponent } from './user-position/user-position.component';


export const AppRoutes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
    },
    {
        path: 'dashboard',
        component: DashboardComponent
    },
    {
        path: 'uploadMaster',
        component: UploadMasterComponent
    },
    {
        path: 'viewMaster',
        component: ViewMasterComponent
    },
    {
        path: 'notification',
        component: NotificationComponent
    },
    {
        path: 'userPosition',
        component: UserPositionComponent
    },
    {
        path: 'login',
        component: LoginComponent
    },
    { path: '**', redirectTo: 'login' }
	

]




// WEBPACK FOOTER //
// ./src/app/app.routing.ts